module.exports = __webpack_public_path__ + "static/media/green_bg.6795b65a.png";